
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/articles/assisted-living",
      function () {
        return require("private-next-pages/resources/articles/assisted-living.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/articles/assisted-living"])
      });
    }
  